import { render, staticRenderFns } from "./PurchaseOrderCard.vue?vue&type=template&id=5572379e&scoped=true"
import script from "./PurchaseOrderCard.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderCard.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderCard.vue?vue&type=style&index=0&id=5572379e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572379e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/InputFromPurchaseOrder/PurchaseOrderCard.vue
// module id = 2388
// module chunks = 31